import { configureStore } from '@reduxjs/toolkit';
import forceReloadReducer from '../reduxStore/forceReloadReducer';
import SettingsReducer from '../reduxStore/SettingsReducer';
import UserReducer from '../reduxStore/UserReducer';
import TranslateReducer from '../reduxStore/TranslateReducer';
import themeReducer from '../reduxStore/themeReducer';
import RolesReducer from '../reduxStore/RolesReducer';
import systemSettingsReducer from '../reduxStore/systemSettingsReducer';


export default configureStore({
  reducer: {
    forceReload: forceReloadReducer,
    settingsData: SettingsReducer,
    userData: UserReducer,
    translateData: TranslateReducer,
    themeData: themeReducer,
    rolesData: RolesReducer,
    systemSettings: systemSettingsReducer

  },
});
